import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=463619a6"
import script from "./PersonalInfo.vue?vue&type=script&lang=ts"
export * from "./PersonalInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports